import React, { memo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  problem__type__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginTop: 9,
    marginBottom: 9,
    paddingLeft: 9,
  },
  tableCol1Header: {
    width: 34 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingTop: 4,
    paddingBottom: 4,
  },
  tableColLastHeader: {
    width: 60 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    paddingTop: 4,
    paddingBottom: 4,
    borderTopRightRadius: 0,
  },
  tableColFirstHeader: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingTop: 4,
    paddingBottom: 4,
    borderTopLeftRadius: 0,
    alignItems: 'center',
  },

  tableColFirst: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    alignItems: 'center',
  },
  tableCol1: {
    width: 34 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
  },

  tableCollast: {
    width: 60 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    paddingLeft: 3,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    marginTop: 9,
    marginBottom: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingLeft: 3,
    paddingRight: 3,
  },
  tableRow__heading: {
    margin: 'auto',
    flexDirection: 'row',
    alignItems: 'flex-start',
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    width: 100 + '%',
  },
});

const OBDTable = ({ recommendations = [] }) => {
  return (
    <>
      <View>
        <View style={styles.tableRow__heading}>
          <Text style={styles.problem__type__heading}>OBD Error Codes:</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColFirstHeader}>
              <Text style={styles.tableCellHeader}>Sr#</Text>
            </View>
            <View style={styles.tableCol1Header}>
              <Text style={styles.tableCellHeader}>Error Code</Text>
            </View>
            <View style={styles.tableColLastHeader}>
              <Text style={styles.tableCellHeader}>Description</Text>
            </View>
          </View>

          {recommendations?.map((rec, i) => (
            /* ---------------Parts Map---------- */
            <View style={styles.tableRow} key={i++}>
              <View style={styles.tableColFirst}>
                <Text style={styles.tableCell}>{i + 1}</Text>
              </View>
              <View style={styles.tableCol1}>
                <Text style={styles.tableCell}>{rec.title}</Text>
              </View>
              <View style={styles.tableCollast}>
                <Text style={styles.tableCell}>{rec?.description}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
    </>
  );
};
export default memo(OBDTable);
